import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import styles from "../../../styles.module.css";
import { getDeliveryChallanList, editDeleteDeliveryChallan, getDeliverycustomerChallanList, editDeleteDeliverycustomerChallan } from "../../../actions/actions";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler
} from "../../reusableComponent/Reusables";
import deliveryChallanCustomerService from "../../../services/deliveryChallanCustomerService";
import HeaderSection from "../../reusableComponent/HeaderSection";

import DeliveryChallancustomerPrint from "./DeliveryChallanCustomerPrint";
import ReactToPrint from "react-to-print";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const DeliveryChallanCustomerList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.delivery_challan_customer.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.delivery_challan_customer.rows_per_page || 15);
  // const rows = useSelector((state) => state.delivery_challan_customer.delivery_challan_customer);
  const [rows, setRows] = useState([]);
  // const deliveryData = useSelector((state) => state.delivery_challan_customer.delivery_challan_customer);
  // const rows = Array.isArray(deliveryData?.rows) ? deliveryData.rows : [];



  const [searchKey, setSearchKey] = useState("");

  const fields = ["dcs_no", "entry_date", "driver_name", "vehicle_no"];
  const labels = ["DC No", "DC Date", "Driver Name", "Vehicle No"];
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });
  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };
  const ComponentToPrintWrapper = ({ quotationPrint }) => {
        const ref = useRef();
        return (
            <div style={{ display: "flex" }}>
                <ReactToPrint
                    trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}> <PrintOutlinedIcon /> <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                    content={() => ref.current}
                />
                <div style={{ display: 'none' }}>
                    <DeliveryChallancustomerPrint ref={ref} salesOrderPrint={quotationPrint} />
                </div>
            </div>
        );
        
    };
  

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await deliveryChallanCustomerService.getDeliverycustomerChallanList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue); 

  
    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };

    try {
      // Fetch data using the fetchData function (assuming fetchData is already declared)
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await deliveryChallanCustomerService.editDeleteDeliverycustomerChallan({
        delivery_challan_customer_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    console.log("handleDelete called with data:", functions);
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = useSelector((state) => state.delivery_challan_customer.message);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

  // useEffect(() => {
  //   if (respMsgState) {
  //     setSuccessMessage(respMsgState);
  //   }
  // }, [respMsgState]);

  // useEffect(() => {}, [shouldShowMsg, responseMessage]);

  // Handle sorting - Fixed the eq issue and added proper sorting
  const HandleSort = (field) => {
    const newSortBy = sortBy === field ? null : field;
    setSortBy(newSortBy);

    // Sort rows by the clicked field
    if (newSortBy) {
      rows.sort((a, b) => {
        if (a[newSortBy] < b[newSortBy]) return -1;
        if (a[newSortBy] > b[newSortBy]) return 1;
        return 0;
      });
    } else {
      // If no sort field, reset the rows to original order (assuming you keep the original data in state)
      fetchData();
    }
  };



  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });




  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            { name: "DC List" },
          ]}
        />




        <HeaderSection
          title="Delivery Challan Customer List"
          addNewPath="/LogisticDistribution/add-customerdc"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="DC Customer List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          openscanner={true}
        />



        <Paper sx={{ width: '100%',  }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>

                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("entry_date")}
                  >
                    DC Date
                    <span className={`${styles.sort_icon}`}>{sortBy === "entry_date" ? "▲" : "▼"}</span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("dc_no")}
                  >
                    DCC No
                    <span className={`${styles.sort_icon}`}>{sortBy === "entry_no" ? "▲" : "▼"}</span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("customer_name ")}
                  >
                    Customer Name
                    <span className={`${styles.sort_icon}`}>{sortBy === "customer_name " ? "▲" : "▼"}</span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("cylinder_no")}
                  >
                    No Of Cylinders
                    <span className={`${styles.sort_icon}`}>{sortBy === "cylinder_no" ? "▲" : "▼"}</span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("driver_name")}
                  >
                    Driver Name
                    <span className={`${styles.sort_icon}`}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                  </StyledTableCell>

                  <StyledTableCell
                    align="right"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("total_qty")}
                  >
                    Total Qty
                    <span className={`${styles.sort_icon}`}>{sortBy === "total_qty" ? "▲" : "▼"}</span>
                  </StyledTableCell>



                  <StyledTableCell align="center" className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.map((row, index) => (
                  <StyledTableRow key={row.delivery_challan_customer_id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>


                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.entry_date}
                    </StyledTableCell>


                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                      {row.entry_no}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.customer_name}
                    </StyledTableCell> 
                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                      {row.cylinder_no}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.driver_name}
                    </StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.total_qty}
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/LogisticDistribution/add-customerdc"
                        PrintComponent={DeliveryChallancustomerPrint}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>


        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.delivery_challan_customer_id || null}
          displayName={deleteInfo?.delivery_challan_customer_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default DeliveryChallanCustomerList;
